export default {
  floatingButton: {
    height: '68px',
  },
};
